import { useEffect } from "react";
import { useState } from "react";
import { Modal, Col, Row, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { getAllBanks } from "../../../../Helpers/apiCalls/banksAPi";
import {
    getAllCreditCards,
    addCardTransaction,
} from "../../../../Helpers/apiCalls/Manage/CreditCards"
import {
    paymentModal,
    getSingleSuppliesExpense,
} from "../../../../Helpers/apiCalls/Purchases/suppliesExpensesApi";
import {
    paymentModalPotato,
} from "../../../../Helpers/apiCalls/PotatoCorner/Purchases/suppliesExpensesApi";
import {
    getTodayDateISO,
    refreshPage,
    toastStyle,
    numberFormat,
} from "../../../../Helpers/Utils/Common";
import { validatePoPayment } from "../../../../Helpers/Validation/Purchase/PurchaseOrderValidation";
import InputError from "../../../../Components/InputError/InputError";

export default function PoPaymentModal({
    id,
    show,
    onHide,
    balance = "",
    payee
}) {
    let navigate = useNavigate();
    const [banks, setBanks] = useState([]);
    const [bankTo, setBankTo] = useState([]);
    const [bankValue, setBankValue] = useState({
        name: "from_bank_id",
        label: "",
        value: "",
    });
    const [depositValue, setDepositValue] = useState({
        name: "to_bank_id",
        label: "",
        value: "",
    });
    const [creditCards, setCreditCards] = useState([]);
    const [creditCardValue, setCreditCardValue] = useState({
        name: "credit_card_id",
        label: "",
        value: "",
    });

    const [isErrorPayment, setIsErrorPayment] = useState({
        payment_type: false,
        payment_date: false,
        to_bank_id: false,
        bank_name: false,
        cheque_number: false,
        cheque_date: false,
        reference_number: false,
        credit_card_id: false,
    });

    const [poPayment, setpoPayment] = useState(
        {
            to_bank_id: "",
            bank_name: "",
            cheque_number: "",
            cheque_date: "",
            reference_number: "",
            credit_card_id: "",
        }
    );
    function handleCreatePayment(e) {
        const { name, value } = e.target;
        if (name === "from_bank_id") {
            setBankValue(() => {
                return { name: name, value: value, label: e.label };
            });
        } else if (name === "to_bank_id") {
            setDepositValue(() => {
                return { name: name, value: value, label: e.label };
            });
        }
        setpoPayment((prev) => {
            return {
                ...prev,
                [name]: value,
            };
        });
    }
    function handleCreditCardChange(selected) {
        setCreditCardValue(selected);
        setpoPayment((prev) => ({
            ...prev,
            credit_card_id: selected.value,
        }));
    }

    async function fetchBanks() {
        const response = await getAllBanks();
        var banks = response.data.data.sort((a, b) =>
            a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );

        var cleanedArray = banks.map((bank) => {
            var info = {};

            info.name = "from_bank_id";
            info.label = bank.bank_name;
            info.value = bank.id;

            return info;
        });
        setBanks(cleanedArray);

        var cleanedArray2 = banks?.map((bank) => {
            var info = {};

            info.name = "to_bank_id";
            info.label = bank.bank_name;
            info.value = bank.id;

            return info;
        });
        setBankTo(cleanedArray2);
    }
    async function fetchCreditCards() {
        const response = await getAllCreditCards();
        const list = response?.data?.data?.data;
        if (Array.isArray(list)) {
            const cleaned = list.map((card) => ({
                name: "credit_card_id",
                label: `${card.name} (••${String(card.card_no).slice(-4)})`,
                value: card.id,
                card_no: card.card_no,
                card_name: card.card_name,
                credit_limit: Number(card.credit_limit || 0),
                current_bal: Number(card.current_bal || 0),
            }));
            setCreditCards(cleaned);
        } else {
            console.warn("fetchCreditCards: unexpected response shape", response);
        }
    }
    async function pay() {
    if (
        validatePoPayment(
            poPayment,
            setIsErrorPayment
        )
    ) {
        const response = await paymentModal(
            id,
            poPayment,
            balance,
            payee
        );
        if (response.data) {
            if (response.data.response === "payment added successfully") {
                if (poPayment.payment_type === "credit_card") {
                    const txnForm = new FormData();
                    txnForm.append("credit_card_id", poPayment.credit_card_id);
                    txnForm.append("type", "expense");
                    txnForm.append("txn_date", poPayment.payment_date);
                    txnForm.append("amount", poPayment.paid_amount || balance);
                    txnForm.append("remarks", `PO Payment - ${poPayment.reference_number}`);
                    await addCardTransaction(txnForm);
                }
                toast.success("Payment saved!", {
                    style: toastStyle(),
                });
                setTimeout(() => refreshPage(), 1000);
            }
        } else if (response.error) {
            var errMsg = response.error.response.data.messages.error;
            toast.error(errMsg, { style: toastStyle() });
            setTimeout(() => refreshPage(), 1000);
        }
    } else {
        toast.error("Please fill in all fields", { style: toastStyle() });
        }
    }

    useEffect(() => {
        fetchBanks();
        fetchCreditCards();
        setpoPayment({
            payment_date: getTodayDateISO(),
            deposit_date: getTodayDateISO(),
            payment_type: "cash",
            paid_amount: balance,

            check_date: "",
            check_number: "",
            bank_name: "",

            payment_description: "",
        });
    }, []);

    // Prefill payment method from the recurring PO template when this PO
    // is the currently-generated instance of one paid by credit card.
    useEffect(() => {
        async function prefillFromRecurringPo() {
            if (!show || !id) return;

            const response = await getSingleSuppliesExpense(id);
            const supplies_expense = response?.data?.data?.[0];
            if (!supplies_expense || supplies_expense.recurring_payment_type !== "credit_card") return;

            const matchedCard = creditCards.find(
                (card) => String(card.value) === String(supplies_expense.recurring_payment_option_id)
            );

            setpoPayment((prev) => ({
                ...prev,
                payment_type: "credit_card",
                credit_card_id: supplies_expense.recurring_payment_option_id,
            }));

            if (matchedCard) {
                setCreditCardValue(matchedCard);
            }
        }
        prefillFromRecurringPo();
    }, [id, show, creditCards]);

    return (
        <div>
            <Modal show={show} onHide={onHide} size="lg" centered>
                <Modal.Header closeButton>
                    <span className="page-title"> Add Payment</span>
                </Modal.Header>
                <Modal.Body className="return-body">
                    <div>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Payment Date
                                    <span className="color-red"> *</span>
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Control
                                    type="date"
                                    name="payment_date"
                                    className="nc-modal-custom-text"
                                    defaultValue={
                                        poPayment.payment_date
                                    }
                                    onChange={(e) => handleCreatePayment(e)}
                                />
                            </Col>
                            <InputError
                                    isValid={isErrorPayment.payment_date}
                                    message={"Payment date is required"}
                                />
                        </Row>
                        <Row className="mt-4 mb-2">
                            <Col>
                                <span className="edit-label">
                                    Payment Method
                                </span>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Check
                                    inline
                                    label="Cash"
                                    name="payment_type"
                                    value="cash"
                                    type="radio"
                                    checked={poPayment.payment_type === "cash"}
                                    onChange={(e) => {
                                        handleCreatePayment(e);
                                    }}
                                />
                                <Form.Check
                                    inline
                                    label="Check"
                                    name="payment_type"
                                    type="radio"
                                    value="check"
                                    checked={poPayment.payment_type === "check"}
                                    onChange={(e) => {
                                        handleCreatePayment(e);
                                    }}
                                />
                                <Form.Check
                                    inline
                                    label="Credit Card"
                                    name="payment_type"
                                    value="credit_card"
                                    type="radio"
                                    checked={poPayment.payment_type === "credit_card"}
                                    onChange={(e) => { handleCreatePayment(e); }}
                                />
                                <Form.Check
                                    inline
                                    label="Others"
                                    name="payment_type"
                                    value="others"
                                    type="radio"
                                    checked={poPayment.payment_type === "others"}
                                    onChange={(e) => {
                                        handleCreatePayment(e);
                                    }}
                                />
                            </Col>
                            <InputError
                                isValid={isErrorPayment.payment_type}
                                message={"Payment type is required"}
                            />
                            <Col>
                                <span className="">Balance:</span>
                                <span className="edit-label"> </span>
                                <span className="">{balance}</span>
                            </Col>
                        </Row>
                    </div>

                    {/* CASH PAYMENT DETAILS */}
                    {poPayment.payment_type === "cash" && (
                        <>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Paid Amount
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="paid_amount"
                                        className="nc-modal-custom-text"
                                        defaultValue={balance}
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposit Date
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="deposit_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            poPayment.deposit_date
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposited to
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="to_bank_name"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.to_bank_name
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.to_bank_name}
                                        message={"Bank name is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Term (days)
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="term_days"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.term_days
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Payee
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="payee"
                                        className="nc-modal-custom-text"
                                        value={
                                            payee
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Remarks
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        as="textarea"
                                        name="remarks"
                                        value={
                                            setpoPayment.remarks
                                        }
                                        className="nc-modal-custom-text"
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                    {/* CHECK PAYMENT DETAILS */}
                    {poPayment.payment_type === "check" && (
                        <>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Paid Amount
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="paid_amount"
                                        className="nc-modal-custom-text"
                                        defaultValue={balance}
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Bank Name
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="bank_name"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.bank_name
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.bank_name}
                                        message={"Bank name is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Check Date
                                    </span>
                                </Col>
                                <Col>
                                    <span className="edit-label">
                                        Check Number
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="cheque_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            poPayment.cheque_date
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.cheque_date}
                                        message={"Check date is required"}
                                    />
                                </Col>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="cheque_number"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            poPayment.cheque_number
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.cheque_number}
                                        message={"Cheque number is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposit Date
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="deposit_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            poPayment.deposit_date
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposited to
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="to_bank_name"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.to_bank_name
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.to_bank_name}
                                        message={"Bank name is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Term (days)
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="term_days"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.term_days
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Remarks
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        as="textarea"
                                        name="remarks"
                                        value={poPayment.remarks}
                                        className="nc-modal-custom-text"
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                    {/* CREDIT CARD PAYMENT DETAILS */}
                    {poPayment.payment_type === "credit_card" && (
                        <>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Paid Amount
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="paid_amount"
                                        className="nc-modal-custom-text"
                                        defaultValue={balance}
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Credit Card
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                                <Col>
                                    <span className="edit-label">
                                        Payment Date
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                                <Col>
                                    <span className="edit-label">
                                        Reference No.
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Select Credit Card..."
                                        value={creditCardValue}
                                        options={creditCards}
                                        onChange={handleCreditCardChange}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.credit_card_id}
                                        message={"Credit card is required"}
                                    />
                                </Col>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="payment_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={poPayment.payment_date}
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="reference_number"
                                        className="nc-modal-custom-text"
                                        value={poPayment.reference_number}
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.reference_number}
                                        message={"Reference number is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">Payee</span>
                                </Col>
                            </Row>
                            {creditCardValue?.value && (
                                <>
                                    <Row className="mt-4 mb-2">
                                        <Col>
                                            <span className="edit-label">Card Number</span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">Cardholder Name</span>
                                        </Col>
                                        <Col>
                                            <span className="edit-label">Available Credit</span>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                disabled
                                                className="nc-modal-custom-text"
                                                value={`••••${String(creditCardValue.card_no || "").slice(-4)}`}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                disabled
                                                className="nc-modal-custom-text"
                                                value={creditCardValue.card_name || ""}
                                            />
                                        </Col>
                                        <Col>
                                            <Form.Control
                                                type="text"
                                                disabled
                                                className={`nc-modal-custom-text ${
                                                    (creditCardValue.credit_limit - creditCardValue.current_bal) < Number(poPayment.paid_amount || 0)
                                                        ? "color-red"
                                                        : ""
                                                }`}
                                                value={`PHP ${numberFormat(
                                                    (creditCardValue.credit_limit || 0) - (creditCardValue.current_bal || 0)
                                                )}`}
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )}
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="payee"
                                        className="nc-modal-custom-text"
                                        value={payee}
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Remarks
                                        <span className="edit-optional px-2">(Optional)</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        as="textarea"
                                        name="remarks"
                                        value={poPayment.remarks}
                                        className="nc-modal-custom-text"
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                    {/* OTHERS PAYMENT DETAILS */}
                    {poPayment.payment_type === "others" && (
                        <>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Paid Amount
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="paid_amount"
                                        className="nc-modal-custom-text"
                                        defaultValue={balance}
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposit Date
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="date"
                                        name="deposit_date"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            poPayment.deposit_date
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Deposited to
                                        <span className="color-red"> *</span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="to_bank_name"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.to_bank_name
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.to_bank_name}
                                        message={"Bank name is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Payment Description
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="remarks"
                                        className="nc-modal-custom-text"
                                        defaultValue={
                                            poPayment.remarks
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Reference Number
                                        <label className="badge-required">{` *`}</label>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="reference_number"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.reference_number
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                    <InputError
                                        isValid={isErrorPayment.reference_number}
                                        message={"Reference number to is required"}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Term (days)
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="text"
                                        name="term_days"
                                        className="nc-modal-custom-text"
                                        value={
                                            poPayment.term_days
                                        }
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-4 mb-2">
                                <Col>
                                    <span className="edit-label">
                                        Remarks
                                        <span className="edit-optional px-2">
                                            (Optional)
                                        </span>
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form.Control
                                        as="textarea"
                                        name="remarks"
                                        value={poPayment.remarks}
                                        className="nc-modal-custom-text"
                                        onChange={(e) => handleCreatePayment(e)}
                                    />
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="return-footer">
                    <button
                        type="button"
                        className="button-secondary"
                        onClick={onHide}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="button-primary"
                        onClick={() => pay()}
                    >
                        Pay
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}